export default __webpack_public_path__ + "media/images/images/banner/banner-1-63523c0a46d9199dee1bd153cd7c743e.jpg";